import { createStore } from "vuex";
import {
  getModule,
  Module,
  Mutation,
  MutationAction,
  Action,
  VuexModule,
} from "vuex-module-decorators";

const shopInfo = createStore({
  state: {
    shopInfo: null,
  },
  mutations: {
    setShopInfo(state, shopInfo) {
      state.shopInfo = shopInfo;
    },
  },
  actions: {},
  modules: {},
});

/**
 * ユーザー属性 Store
 */
@Module({ dynamic: true, store: shopInfo, name: "shopStore" })
class ShopStore extends VuexModule {
  public chain_code = "";
  public shop_code = "";
  public shipping_label_print_flg = 0;
  public delivery_order_print_flg = 0;
  public tmp_member_registration_flg = 0;
  public double_deli_oricon_count: number | null | undefined = null;
  public charter_deli_oricon_count: number | null | undefined = null;
  public shop_address: string | null | undefined = null;

  get hasValue(): boolean {
    return this.chain_code !== "" && this.shop_code !== "";
  }

  get getShippingLabelPrintFlg(): boolean {
    return Boolean(this.shipping_label_print_flg);
  }

  get getDeliveryOrderPrintFlg(): boolean {
    return Boolean(this.delivery_order_print_flg);
  }

  get getTmpMemberRegistrationFlg(): boolean {
    return Boolean(this.tmp_member_registration_flg);
  }

  get getDoubleDeliOriconCount(): number | null | undefined {
    return this.double_deli_oricon_count !== null &&
      this.double_deli_oricon_count !== undefined
      ? Number(this.double_deli_oricon_count)
      : this.double_deli_oricon_count;
  }

  get getCharterDeliOriconCount(): number | null | undefined {
    return this.charter_deli_oricon_count !== null &&
      this.charter_deli_oricon_count !== undefined
      ? Number(this.charter_deli_oricon_count)
      : this.charter_deli_oricon_count;
  }

  get getShopAddress(): string | null | undefined {
    return this.shop_address !== null && this.shop_address !== undefined
      ? String(this.shop_address)
      : this.shop_address;
  }

  // Mutation: shipping_label_print_flg を更新する
  @Mutation
  private SET_SHIPPING_LABEL_PRINT_FLG(flag: number): void {
    this.shipping_label_print_flg = flag;
  }

  // Action: 任意の値を受け取り、ミューテーションをコミットする
  @Action({ rawError: true })
  public updateShippingLabelPrintFlg(flag: number): void {
    this.context.commit("SET_SHIPPING_LABEL_PRINT_FLG", flag);
  }

  // Mutation: delivery_order_print_flg を更新する
  @Mutation
  private SET_DELIVERY_ORDER_PRINT_FLG(flag: number): void {
    this.delivery_order_print_flg = flag;
  }

  // Action: 任意の値を受け取り、ミューテーションをコミットする
  @Action({ rawError: true })
  public updateDeliveryOrderPrintFlg(flag: number): void {
    this.context.commit("SET_DELIVERY_ORDER_PRINT_FLG", flag);
  }

  // Mutation: tmp_member_registration_flg を更新する
  @Mutation
  private SET_TMP_MEMBER_REGISTRATION_FLG(flag: number): void {
    this.tmp_member_registration_flg = flag;
  }

  // Action: 任意の値を受け取り、ミューテーションをコミットする
  @Action({ rawError: true })
  public updateTmpMemberRegistrationFlg(flag: number): void {
    this.context.commit("SET_TMP_MEMBER_REGISTRATION_FLG", flag);
  }

  // Mutation: double_deli_oricon_count を更新する
  @Mutation
  private SET_Double_Deli_Oricon_Count(count: number | null | undefined): void {
    this.double_deli_oricon_count = count;
  }

  // Action: 任意の値を受け取り、ミューテーションをコミットする
  @Action({ rawError: true })
  public updateDoubleDeliOriconCount(count: number | null | undefined): void {
    this.context.commit("SET_Double_Deli_Oricon_Count", count);
  }

  // Mutation: charter_deli_oricon_count を更新する
  @Mutation
  private SET_Charter_Deli_Oricon_Count(
    count: number | null | undefined
  ): void {
    this.charter_deli_oricon_count = count;
  }

  // Action: 任意の値を受け取り、ミューテーションをコミットする
  @Action({ rawError: true })
  public updateCharterDeliOriconCount(count: number | null | undefined): void {
    this.context.commit("SET_Charter_Deli_Oricon_Count", count);
  }

  // Mutation: shop_address を更新する
  @Mutation
  private SET_SHOP_ADDRESS(value: string | null | undefined): void {
    this.shop_address = value;
  }

  // Action: 任意の値を受け取り、ミューテーションをコミットする
  @Action({ rawError: true })
  public updateShopAddress(value: string | null | undefined): void {
    this.context.commit("SET_SHOP_ADDRESS", value);
  }

  /**
   * ユーザー属性値を設定
   *
   * @param store
   */
  @MutationAction({
    rawError: true,
    mutate: ["chain_code", "shop_code"],
  })
  async setupValue(store: {
    chain_code: string;
    shop_code: string;
    shipping_label_print_flg: number;
    delivery_order_print_flg: number;
  }): Promise<
    ShopStore & {
      chain_code: string;
      shop_code: string;
    }
  > {
    return {
      chain_code: store.chain_code,
      shop_code: store.shop_code,
    } as ShopStore & {
      chain_code: string;
      shop_code: string;
    };
  }
}
export default getModule(ShopStore, shopInfo);
